import React, {useState,useContext,useRef} from 'react';
import { Row, Col, Badge, Table, Spinner,Modal,Button, Form } from 'react-bootstrap';
import { number_format, getDepartamento } from '../../utils/utils';
import { ModalConfirmacion } from '../../utils/modals';
import toast, { Toaster } from 'react-hot-toast';
import { AuthContext } from '../../auth/AuthContext';

import { useSelector,useDispatch } from 'react-redux';
import { setInitData, quitarPagoRecibo, setStateGlobal, showAlert, } from '../../reducers/appReducer';

import '../Directory/Directory.css';
import moment from "moment";
import "moment/locale/es";
moment.locale("mx");

const BarraProgreso = ({percent}) => {
  return(
    <div style={{backgroundColor:'#fff',borderRadius:'10px',width:'90%',height:'20px',padding:'4px',border:'1px solid #ccc'}} title={percent+"%"}> 
      <div style={{maxWidth:'100%',width:`${percent}%`,borderRadius:'10px',backgroundColor:'#f4244c',height:'10px',fontSize:'.6rem',color:'#fff',textAlign:'center'}} ></div>
    </div>
  )
}

const formMotivo = (props) => {
  return(
    <div> 
      {
        props.children
      }
    </div>
  )
}

const getItemByArrProcess = (_item, id) => {

  let itemTramite, _tmp = _item
  // Posición 0 en arrOT significa le primer trámite (pensamos en un multitrámites en algún momento)
  const arrProcess = _tmp.arrOT[0].arrProcess

  for(var a in arrProcess) {
    if(arrProcess[a].id === id) {
      itemTramite = arrProcess[a]
    }
  }

  return itemTramite
}

const TablaRecibos = ({state,setState,filteredData,typeView,reloadData}) => {

  const refMotivo = useRef(null);

  const {usuario} = useContext(AuthContext);
  const stateGlobal = useSelector( (state) => state.agents );
  const initData = useSelector( (state) => state.agents.initData );
  const stateHome = useSelector( (state) =>  state.agents.home );
  const { isLoadPanel,section } = stateHome;
  const dispatch = useDispatch();
  let colorLabel = "green";
  if(section===2) colorLabel = "green";
  if(section===3) colorLabel = "#FF3624";

  const [stateRecibo,setStateRecibo] = useState({
    isLoading: false,
    error: false,
    errorMessage: '',
  })

  const [modalConfirmar,setModalConfirmar] = useState(false);
  const [modalConfirmacion,setModalConfirmacion] = useState(false);
  const [modalConfirmacionDeclinar,setModalConfirmacionDeclinar] = useState(false);
  const [modalConfirmacionAutorizar,setModalConfirmacionAutorizar] = useState(false);
  const [modalIniciarTramite,setModalIniciarTramite] = useState(false);
  const [dataSelected,setDataSelected] = useState([]);
  const [nombreCompania,setNombreCompania] = useState('');
  const [numeroPoliza,setNumeroPoliza] = useState('');
  const [pagados,setPagados] = useState(2);
  const [btnLoadingIniciarTramite, setBtnLoadingIniciarTramite] = useState(false);
  const [btnLoadingChangeToCredito, setBtnLoadingChangeToCredito] = useState(false);
  const [btnLoadingDeclinarCredito, setBtnLoadingDeclinarCredito] = useState(false);

  const handleShowModalConfirmacion = () => setModalConfirmacion(true);
  const handleCloseModalConfirmacion = () => setModalConfirmacion(false);

  const compareRegByID = (arrProcess, urgente) => {

    return true
    /*
    for(var a in arrProcess) {

      if(stateGlobal.showUrgentes) {

        // Si la actividad tiene status realizado
        if(urgente)
          return true
        return false
      } else {

        // Si la actividad tiene status realizado
        if(arrProcess[a].view) {
          // console.log( arrProcess[a].id,  stateHome.arrSections[arrProcess[a].id] )
          if(stateHome.arrSections[arrProcess[a].id] )
            return true
        }
      }


    }
    */

    return false
  }

  const showToast = (message) => {
    toast.success( (e) => (
      <p className="mb-0">{message}</p>
    ),{
      duration: 2000
    });
  }

  const calculateFaltante = (faltante, arrCobranza) => {
    // faltante = faltante.replace('$', '')
    // faltante = faltante.replace(',', '')
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    return "$" + number_format(faltante - totalAbonos)
  }

  const calculaPorcentaje = (faltante, arrCobranza) => {
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    

    if(arrCobranza.length === 0)
      return 0
    return ((totalAbonos * 100) / faltante).toFixed(0); 
  }

  const isPayed = (tramite) => {
    const { arrOT,arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    // console.log('totalAbonos1: ', (parseFloat(cantidad) - totalAbonos));
    const itemProcesos = getItemByArrProcess(tramite, 'procesos')
    const itemOrden_trabajo = getItemByArrProcess(tramite, 'orden_trabajo')
    return ( (parseFloat(cantidad) - totalAbonos) <= 0 && itemProcesos.status == 2 && itemOrden_trabajo.status == 2) ? true : false;
  }

  const isNotPayed = (tramite) => {
    const { arrOT,arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    const itemProcesos = getItemByArrProcess(tramite, 'procesos')
    return ( (parseFloat(cantidad) - totalAbonos) > 0 && itemProcesos.status!==2) ? true : false;
  }

  const isFinishedButNotPayed = (tramite) => {
    const { arrOT,arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    const itemProcesos = getItemByArrProcess(tramite, 'procesos')
    return ( (parseFloat(cantidad) - totalAbonos) > 0 && itemProcesos.status==2) ? true : false;
  }

  const isFinishedButNotNotify = (tramite) => {
    const { arrOT,arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    const itemOrden_trabajo = getItemByArrProcess(tramite, 'orden_trabajo')
    return ( itemOrden_trabajo.status==4) ? true : false;
  }

  const isPayedButNotFinished = (tramite) => {
    const { arrOT,arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    const itemProcesos = getItemByArrProcess(tramite, 'procesos')
    return ( (parseFloat(cantidad) - totalAbonos) <= 0 && itemProcesos.status!==2) ? true : false;
  }

  const actualizarTramiteOt = (tramite) => {
    console.table(tramite);
    return false;
    //Enviar whatsapp a atención a clientes de que ya se libero
    const data = {
      id_cotizacion: tramite.id_cotizacion
    }
    fetch('',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( res => {
      // console.log(res)
    })
  }

  const changeToCredito = () => {
    const { dataTramite } = stateGlobal;

    const arrHistory = [...dataTramite.arrOT[0].arrHistory, {
      usuario_nombre: usuario.nombre, fecha: moment().format('YYYY-MM-DD HH:mm:ss'), motivo: "Cambió este trámite de contado a crédito", id: 'cotizaciones',
    }]

    const data = {
      id_cotizacion: dataTramite.id_cotizacion,
      metodo_pago : 'credito',
      tramite_iniciado: true,
    }

    setBtnLoadingChangeToCredito(true);

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramite', {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then( res => {

      const dataFinanzas = {
        id_cotizacion: dataTramite.id_cotizacion,
        authorization_finanzas: false,
      }
      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateAutorizacionFinanzas', {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(dataFinanzas)
      })
      .then( response => response.json())
      .then( res => {
        // console.log(res)
      })

      const dataBitacora = {
        area: getDepartamento(typeView),
        razon: 'Se actualizó el método de pago de contado a crédito',
        id_cotizacion: dataTramite.id_cotizacion,
        usuario: usuario.nombre
      }

      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveBitacora', {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(dataBitacora)
      })
      .then( response => response.json())
      .then( res => {

        let _dataTramite = [], _tmp = dataTramite;
        for(var a in _tmp.arrOT[0].arrProcess) {
          if(_tmp.arrOT[0].arrProcess[a].id === 'cotizaciones') {
            _dataTramite.push({
              ..._tmp.arrOT[0].arrProcess[a],
              status : 2,
            })
          } else if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
            _dataTramite.push({
              ..._tmp.arrOT[0].arrProcess[a],
              status : 0,
            })
          } else if(_tmp.arrOT[0].arrProcess[a].id === 'caja') {
            _dataTramite.push({
              ..._tmp.arrOT[0].arrProcess[a],
              status : 0,
            })
          } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
            _dataTramite.push({
              ..._tmp.arrOT[0].arrProcess[a],
              status: 1,
            })
          } else {
            _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
          }
        }


        const arrHistory = [...dataTramite.arrOT[0].arrHistory, {
          usuario_nombre: usuario.nombre, fecha: moment().format('YYYY-MM-DD HH:mm:ss'), motivo: "Inició el trámite", id: 'cotizaciones',
        }, {
          usuario_nombre: usuario.nombre, fecha: moment().format('YYYY-MM-DD HH:mm:ss'), motivo: "Cambió este trámite de contado a crédito", id: 'cotizaciones',
        }]
        const dataUpdate = {
          arrProcess: _dataTramite,
          arrHistory,
          id_cotizacion: dataTramite.id_cotizacion,
        }

        fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(dataUpdate),
        })
        .then( response => response.json())
        .then( response => {
          window.location.href = "";
          // Notificar a finanzas sobre un nuevo crédito
          
          // alert('Orden de trabajo terminada con éxito')
          // socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
        })

      })

      
      
    })
  }

  const autorizarCredito = () => {
    const { dataTramite } = stateGlobal;

    let _dataTramite = [], _tmp = dataTramite;
    for(var a in _tmp.arrOT[0].arrProcess) {
      if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 1,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 2,
        })
      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }
    }

    const dataUpdate = {
      arrProcess: _dataTramite,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {
      const dataFinanzas = {
        id_cotizacion: dataTramite.id_cotizacion,
        authorization_finanzas: true,
      }
      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateAutorizacionFinanzas',{
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(dataFinanzas)
      })
      .then( response => response.json())
      .then( res => {
        alert('Autorización realizada con éxito')
        window.location.href = "";
      })
    })
  }

  const declinarCredito = () => {
    const { dataTramite } = stateGlobal;

    if(refMotivo.current.value===''){
      dispatch( showAlert( {
        show : true, 
        message : 'El motivo es requerido',
        type: 'error',
        duration: 2000,
      } ) )
      refMotivo.current.focus()
      return false;
    }

    let _dataTramite = [], _tmp = dataTramite;
    for(var a in _tmp.arrOT[0].arrProcess) {
      if(_tmp.arrOT[0].arrProcess[a].id === 'cotizaciones'){
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 3,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 3,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'caja') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 3,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 3,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 3,
        })
      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }
    }

    const dataUpdate = {
      arrProcess: _dataTramite,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    setBtnLoadingDeclinarCredito(true);

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {

      const dataBitacora = {
        area: getDepartamento(typeView),
        razon: 'Se rechazo un crédito',
        id_cotizacion: dataTramite.id_cotizacion,
        usuario: usuario.nombre
      }

      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveBitacora', {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(dataBitacora)
      })
      .then( response => response.json())
      .then( response => {
        setModalConfirmacionDeclinar(false)
        setBtnLoadingDeclinarCredito(false)
        reloadData()
      })
      // window.location.href = "";
    })

  }

  const iniciarTramite = () => {
    const { dataTramite } = stateGlobal;

    let _dataTramite = [], _tmp = dataTramite;
    for(var a in _tmp.arrOT[0].arrProcess) {
      if(_tmp.arrOT[0].arrProcess[a].id === 'cotizaciones'){
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 2,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 1,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'caja') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 1,
        })
      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }
    }

    let newDataTramite = JSON.parse(JSON.stringify(dataTramite));
    newDataTramite.arrOT[0].arrProcess = _dataTramite;

    const dataIniciarTramite = {
      id_cotizacion: dataTramite.id_cotizacion,
      tramite_iniciado : true
    }

    setBtnLoadingIniciarTramite(true);

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramite', {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(dataIniciarTramite),
    })
    .then( response => response.json() )
    .then( response => { 

      const dataUpdate = {
        arrProcess: _dataTramite,
        id_cotizacion: dataTramite.id_cotizacion,
        atn_iniciado: usuario.nombre,
      }
  
      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(dataUpdate),
      })
      .then( response => response.json())
      .then( response => {
        // window.location.href = "";
        reloadData();
        setBtnLoadingIniciarTramite(false);
        setModalIniciarTramite(false);
        dispatch( setStateGlobal({ showSidebarModificarOT: true, dataTramite: newDataTramite, }))
        // Notificar a finanzas sobre un nuevo crédito
        
        // alert('Orden de trabajo terminada con éxito')
        // socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
      })

    })
    
  }

  const handleSetPagados = (section) => {
    setPagados(section)
  }

  const filterByPayed = (data) => {
    const newData = [];
    data.map((t,e) => {
      if(t.arrCobranza.length > 0) {
        if(isPayed(t)){
          newData.push(t)
        }
      }
    })
    return newData;
  }

  const filterByNoPayed = (data) => {
    const newData = [];
    // console.log('dataPayed', data);

    data.map((t,e) => {
      if(t.arrCobranza.length < 1) {
        newData.push(t)
      }

      if(t.arrCobranza.length > 0) {
        if(isNotPayed(t)){
          newData.push(t)
        }
        if(isPayedButNotFinished(t)){
          newData.push(t)
        }
        if(isFinishedButNotPayed(t)){
          newData.push(t)
        }
        if(isFinishedButNotNotify(t)){
          newData.push(t)
        }
      }
    })
    return newData;
  }

  const filterByActividades = (data) => {
    const newData = [];
    data.map((t,e) => {
      if(t.arrOT && compareTipoUsuario(usuario, t) && compareRegByID(t.arrOT[0].arrProcess, t.urgente)){
        newData.push(t);
      }
    })
    return newData;
  }
  
  const sePuedeLiberar = (arrCobranza,cantidad) => {
    let arrData = false;
    if(arrCobranza.length > 0){
      arrData = arrCobranza.map((a,b,array) => {
        let suma = 0;
        array.map((f,g) => { suma += parseFloat(f.cantidadRecibida) })

        if(suma === parseFloat(cantidad))  { 
          return true
        } else{
          return false
        }
      })[0]
   }
    return arrData ? true : false;
  }
  
  const compareTipoUsuario = (usuario, item) => {
    // Esto debe cambiarse a BD después
    // return true
    if(parseInt(usuario.tipo_usuario) === 1) {
      const itemCotizaciones = getItemByArrProcess(item, 'cotizaciones');
      const itemOrdenTrabajo = getItemByArrProcess(item, 'orden_trabajo');
      return (itemCotizaciones?.status !== 2 || itemOrdenTrabajo?.status !== 2 || calculaPorcentaje(item.cantidad,item.arrCobranza) < 100 ) ? true : false ;
    } else if(parseInt(usuario.tipo_usuario) === 2) {
      // Si es usuario caja y aún no está al 100% el trámite
      return calculaPorcentaje(item.cantidad,item.arrCobranza) < 100 ? true : false
    } else if(parseInt(usuario.tipo_usuario) === 3) {
      // Si es usuario trámites y su estatus es 1 (en su array de arrProcess)
      const itemFinanzas = getItemByArrProcess(item, 'finanzas')
      return itemFinanzas?.status === 1 ? true : false
    } else if(parseInt(usuario.tipo_usuario) === 4) {
      const itemProcesos = getItemByArrProcess(item, 'procesos')
      return itemProcesos?.status === 1 ? true : false
    }
    return true
  }


  let filteredData2 = [];
  if(pagados===1){
    filteredData2 = filterByPayed(filteredData);
  }
  if(pagados===2){
    filteredData2 = filterByNoPayed(filteredData);
  }

  filteredData2 = filterByActividades(filteredData2);

  return(

    <Row>
      
      <Col xs={12} className="mb-2">
        <ul className="nav nav-pills">
          <li className="nav-item">
            <a className={`nav-link ${ (pagados === 1) && 'active' }`} aria-current="page" href="#" onClick={ () => handleSetPagados(1) }>Finalizados</a>
          </li>
          <li className="nav-item">
            <a className={`nav-link ms-2 ${ (pagados === 2) && 'active' }`} href="#" onClick={ () => handleSetPagados(2) }>En proceso</a>
          </li>
        </ul>
      </Col>

      <Col xs={12} md={12} sm={12} xm={12} className="mb-4">
        <div className="ws-box-container">
          { isLoadPanel && (
              <div className="ws-loader-container">
              <Spinner animation="border" variant="danger" size="lg"/>
            </div>) }

          <Table responsive hover>
            <thead>
              <tr>
                <th width="20%">Nombre</th>
                <th width="10%">Número</th>
                <th width="10%">Fecha</th>
                <th width="20%">Servicio</th>
                <th width="10%">Cantidad</th>
                <th width="25%">Progreso</th>
                <th width="5%"></th>
              </tr>
          </thead>
          <tbody>

            {
              // (filteredData2.length < 1) && (
              //   <tr>
              //     <td colSpan={7}> 
              //       <p className="text-center mt-2 mb-2"><b>No tienes actividades1</b></p>
              //     </td>
              //   </tr>
              // )
            }

            {
              (filteredData2.length > 0) ?
                filteredData2.map((t,e) => 
                //  t.arrOT /*&& t.arrOT.length >= 1*/ && compareTipoUsuario(usuario, t) && compareRegByID(t.arrOT[0].arrProcess, t.urgente) ?
                  <tr key={e}>
                    <td style={{ padding: '15px 0', }}>
                      <div style={{display:'inline-block',float:'left',paddingLeft:'5px'}}>
                        <p className="mb-0">{t.nombre}</p>
                        <Badge className="ws-bg-warning ms-1">{t.concepto}</Badge>
                        {
                          (t.vendedor_nombre) && (
                            <p className="mb-0">Vendedor: {t.vendedor_nombre}</p>
                          ) 
                        }
                        {
                          (t.atn_creado) && (
                            <p className="mb-0">Creado por: {t.atn_creado}</p>
                          ) 
                        }
                        {
                          (t.arrOT[0].atn_iniciado) && (
                            <p className="mb-0">Atiende: {t.arrOT[0].atn_iniciado}</p>
                          ) 
                        }
                      </div>
                      {
                        (t.reminder)
                          ? <Badge className="ws-bg-danger ms-1 background-primary">Recordatorio: {t.reminder}</Badge>
                          : null
                      }
                    </td>
                    <td style={{ padding: '15px 0', }}>
                      <p className="mb-0">OT-{e+1}</p>
                      <Badge className="ws-bg-info ms-1">{t.oficina}</Badge>
                    </td>
                    <td style={{ padding: '15px 0', }}>
                      <p className="mb-0">{moment(t.created_at).format('DD/MM/YYYY HH:mm')}</p>
                    </td>
                    <td style={{ padding: '15px 0', }}>
                      <p className="mb-0">{t.concepto2}</p>
                      <p className="mb-0" style={{color:'#777',fontSize:'.8rem', width: '50%', }}>{t.nombre_tipo}</p>
                    </td>
                    <td style={{ padding: '15px 0', }}>

                      <BarraProgreso percent={calculaPorcentaje(t.cantidad,t.arrCobranza)} />
                      <p className="mb-0" style={{fontWeight:'600', margin: 0, }}>Costo del trámite: ${number_format(t.cantidad)}</p>
                      <p style={{fontWeight:'600', margin: 0, }}>Pagado al { calculaPorcentaje(t.cantidad,t.arrCobranza) }%</p>
                      {
                        t.arrCobranza.length > 0 && (
                          <p style={{fontWeight:'600', margin: 0, }}>Faltante: { calculateFaltante(t.cantidad, t.arrCobranza) }</p>
                        )
                      }
                      
                      <Badge className="ws-bg-warning ms-1">{t.metodo_pago}</Badge>
                    </td>
                    <td style={{ padding: '15px 0', }}>
                      <Row>
                      {
                        t.arrOT[0]?.arrProcess && t.arrOT[0].arrProcess.length > 0 && t.arrOT[0].arrProcess.map((t0,e0) => {
                          if(t0.id !== 'caja') {
                            return (
                              <Col key={`sub-${e0}`} className={`ws-process-list-info ${t0.status === 2 ? 'end' : t0.status === 1 ? 'working' : t0.status === 3 ? 'declined' : t0.status === 4 ? 'notify' : ''}`}>
                                <span className="ws-tooltip-top" data-tooltip={
                                  t0.status === 0 ? 'Sin iniciar' : t0.status === 1 ? 'En proceso' : t0.status === 2 ? 'Finalizada' : t0.status === 3 ? 'Declinada' : t0.status === 4 ? 'Falta notificar al cliente' : ''
                                }><p>{t0.nombre}</p></span>
                              </Col>
                            )
                          }
                        })
                      }
                      </Row>
                    </td>
                    <td style={{ padding: '15px 0', }}>
                      <ul className="navbar-nav ms-auto ws-dropdown-list">
                        <li className="nav-item dropdown position-static">
                          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                            <i className="bi bi-three-dots-vertical"></i>
                          </a>
                          <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                            {/*<a className="dropdown-item" href="#"><i className="bi bi-pencil pe-2"></i> Modificar Cotización</a>*/}
                            
                            {
                              typeView === 'home' && getItemByArrProcess(t, 'orden_trabajo')?.status === 4 && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({ showModalNotificarCliente: true, dataTramite: t, }))
                                }} 
                                className="dropdown-item"
                                style={{cursor: 'pointer'}}
                                >
                                  <i className="bi bi-bell"></i> Notificar al cliente
                                </a>
                              )
                            }

                            {
                              typeView === 'home' && t.metodo_pago === 'contado' && getItemByArrProcess(t, 'cotizaciones')?.status === 1 && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({ dataTramite: t }) )
                                  setModalIniciarTramite(true);
                                }} 
                                className="dropdown-item"
                                style={{ cursor: (t.authorization_finanzas) ? 'pointer' : 'not-allowed' }}
                                >
                                  <i className="bi bi-file-earmark-text"></i> Iniciar trámite
                                </a>
                              )
                            }

                            {
                              typeView === 'home' && getItemByArrProcess(t, 'cotizaciones')?.status === 2 && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({ showModalVisualizarOT: true, dataTramite: t, }))
                                }} 
                                className="dropdown-item"
                                style={{cursor: 'pointer'}}
                                >
                                  <i className="bi bi-eye"></i>&nbsp;
                                  {
                                    t.metodo_pago === 'credito' && getItemByArrProcess(t, 'finanzas')?.status !== 2 ? 'Visualizar cotización' : ' Visualizar O.T.'
                                  }
                                </a>
                              )
                            }

                            {
                              typeView === 'home' && t.metodo_pago === 'contado' && !isPayed(t) && getItemByArrProcess(t, 'procesos')?.status !== 2 && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({ dataTramite: t }) )
                                  setModalConfirmacion(true);
                                }} 
                                className="dropdown-item"
                                style={{ cursor: (t.authorization_finanzas) ? 'pointer' : 'not-allowed' }}
                                >
                                  <i className="bi bi-credit-card"></i> Solicitar crédito
                                </a>
                              )
                            }

                            {
                              /*
                              typeView === 'home' && getItemByArrProcess(t, 'cotizaciones')?.status === 2 && getItemByArrProcess(t, 'orden_trabajo')?.status === 1 && (
                                <a 
                                onClick={() => {
                                  if(t.authorization_finanzas){
                                    dispatch( setStateGlobal({ showSidebarModificarOT: true, dataTramite: t, }))
                                  }else{
                                    alert('Lo sentimos, ésta orden de trabajo debe ser primero autorizada por finanzas.');
                                  }
                                }} 
                                className="dropdown-item"
                                style={{ cursor: (t.authorization_finanzas) ? 'pointer' : 'not-allowed' }}
                                >
                                  <i className="bi bi-pencil pe-2" ></i> Modificar O.T.
                                </a>
                              )
                              */
                            }

                            {
                              typeView === 'homeCaja' && calculaPorcentaje(t.cantidad, t.arrCobranza) < 100 && getItemByArrProcess(t, 'cotizaciones')?.status < 3 && (
                                <a 
                                onClick={() => {
                                  if(!t.tramite_iniciado){
                                    alert('Para realizar el cobro es necesario iniciar el trámite.');
                                  }else{
                                    dispatch( setStateGlobal({ showModalRealizarCobro: true, dataTramite: t, }))
                                  }
                                }} 
                                className="dropdown-item"
                                style={{cursor: 'pointer'}}
                                >
                                  <i className="bi bi-pencil pe-2"></i> Realizar cobro
                                </a>
                              )
                            }

                            {
                              typeView === 'homeCaja' && calculaPorcentaje(t.cantidad, t.arrCobranza) == 100 && (
                                <a style={{ cursor: 'not-allowed', }} className="dropdown-item" href="#">El trámite ya está liquidado</a>
                              )
                            }

                            {
                              typeView === 'homeFinanzas' && t.metodo_pago === 'credito' && getItemByArrProcess(t, 'finanzas')?.status === 1 && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({showModalAutorizarTramite: true, dataTramite: t, }))
                                  // setModalConfirmacionAutorizar(true);
                                }} 
                                className="dropdown-item"
                                style={{cursor: 'pointer'}}
                                >
                                  <i className="bi bi-eye pe-2"></i> Ver información
                                </a>
                              )
                            }

                            {
                              typeView === 'homeFinanzas' && t.metodo_pago === 'contado' && getItemByArrProcess(t, 'finanzas')?.status === 0 ||
                              typeView === 'homeFinanzas' && t.metodo_pago === 'contado' && getItemByArrProcess(t, 'finanzas')?.status === 1
                              ?
                                <a 
                                key={`option-liberar-${e}`} 
                                onClick={() => {
                                  if(sePuedeLiberar(t.arrCobranza,t.cantidad)) {
                                    dispatch( setStateGlobal({ showModalAutorizarTramite: true, dataTramite: t, }))
                                  }else{
                                    alert('Se debe tener el 100% del pago en caja y tener liberado OT')
                                  }
                                }} 
                                className="dropdown-item" href="#"
                                style={{
                                  cursor: (sePuedeLiberar(t.arrCobranza,t.cantidad)) ? 'pointer' : 'not-allowed',
                                }}
                                ><i className="bi bi-pencil pe-2"></i> Liberar a procesos</a> 
                              : null
                            }

                            {/* {
                              typeView === 'homeProcesos' && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({ showModalModificarCostoTramite: true, dataTramite: t, }))
                                }} 
                                className="dropdown-item"
                                style={{cursor: 'pointer'}}
                                >
                                  <i className="bi bi-pencil pe-2"></i> Modificar costo de trámite
                                </a>
                              )
                            } */}

                            {/* {
                              typeView === 'homeProcesos' && getItemByArrProcess(t, 'procesos')?.status === 1 && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({ showModalFinalizarProceso: true, dataTramite: t, }))
                                }} 
                                className="dropdown-item"
                                style={{cursor: 'pointer'}}
                                >
                                  <i className="bi bi-check-lg pe-2"></i> Finalizar proceso
                                </a>
                              )
                            } */}

                            {
                              typeView === 'homeProcesos' && getItemByArrProcess(t, 'orden_trabajo')?.status === 2 && getItemByArrProcess(t, 'procesos')?.status === 1 && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({ showModalVisualizarOT: true, dataTramite: t, }))
                                }} 
                                className="dropdown-item"
                                style={{cursor: 'pointer'}}
                                >
                                  <i className="bi bi-eye pe-2"></i> Visualizar O.T.
                                </a>
                              )
                            }

                            {/* {
                              typeView === 'homeProcesos' && getItemByArrProcess(t, 'orden_trabajo')?.status === 2 && getItemByArrProcess(t, 'procesos')?.status === 1 && (
                                <a 
                                onClick={() => {
                                  dispatch( setStateGlobal({ showModalRegresarTramite: true, dataTramite: t, }))
                                }} 
                                className="dropdown-item" 
                                style={{cursor:'pointer'}}
                                >
                                  <i className="bi bi-arrow-counterclockwise pe-2"></i> Regresar trámite
                                </a>
                              )
                            } */}

                            <a 
                            onClick={() => {
                              dispatch( setStateGlobal({ showModalHistorial: true, dataTramite: t, }))
                            }} 
                            className="dropdown-item"
                            style={{cursor: 'pointer'}}
                            >
                              <i className="bi bi-arrow-counterclockwise pe-2"></i> Ver historial
                            </a>

                            {/*<a className="dropdown-item" href="#"><i className="bi bi-archive pe-2"></i> Archivar</a>*/}

                          </div>
                        </li>
                      </ul>
                    </td>
                  </tr>
                //  :  
                //   null
                )
              : 
                <tr>
                  <td colSpan={7}> 
                    <p className="text-center mt-2 mb-2"><b>No tienes actividades</b></p>
                  </td>
                </tr>
            }

          </tbody>
          </Table>

          <ModalConfirmacion 
          show={modalConfirmacionAutorizar} 
          message={<p className="mb-0">¿Deseas autorizar este crédito?</p>} 
          handleDelete={ () => autorizarCredito() }
          handleCancel={ () => setModalConfirmacionAutorizar(false) }
          textConfirm={'Confirmar'}
          textCancel={'Cancelar'}
          isLoading={false}
          />

          <ModalConfirmacion 
          show={modalConfirmacionDeclinar} 
          message={<p className="mb-0">¿Deseas declinar este crédito?</p>} 
          handleDelete={ () => declinarCredito() }
          handleCancel={ () => setModalConfirmacionDeclinar(false) }
          textConfirm={'Confirmar'}
          textCancel={'Cancelar'}
          isLoading={btnLoadingDeclinarCredito}
          children={ 
            <formMotivo>
              <Form className="mt-2">
                <Form.Group>
                  <Form.Label>Agrega el motivo</Form.Label>
                  <Form.Control ref={refMotivo} as="textarea" row="5" />
                </Form.Group>
              </Form>
            </formMotivo> 
          }
          />

          <ModalConfirmacion 
          show={modalConfirmacion} 
          message={<p className="mb-0">¿Deseas cambiar este trámite a crédito?</p>} 
          handleDelete={ () => changeToCredito() }
          handleCancel={ () => setModalConfirmacion(false) }
          textConfirm={'Confirmar'}
          textCancel={'Cancelar'}
          isLoading={btnLoadingChangeToCredito}
          />

          <ModalConfirmacion 
          show={modalIniciarTramite} 
          message={<p className="mb-0">¿Deseas iniciar el trámite de esta cotización?</p>} 
          handleDelete={ () => iniciarTramite() }
          handleCancel={ () => setModalIniciarTramite(false) }
          textConfirm={'Confirmar'}
          textCancel={'Cancelar'}
          isLoading={btnLoadingIniciarTramite}
          />

        </div>
      </Col>
      <Col xs={12} md={12} sm={12} xm={12} className="mb-4">
        <p style={{
          position:'fixed',
          right:'10px',
          bottom:'10px',
          fontWeight:'600',
          fontSize:'1.5rem',
          background: '#fff',
          zIndex: '100'
        }}>
          { typeView === 'home' && usuario.tipo_usuario === '1' && 'Atención a clientes' }
          { typeView === 'home' && usuario.tipo_usuario === '5' && 'Administrador' }
          { typeView === 'homeCaja' && 'Ejecutivo de caja' }
          { typeView === 'homeFinanzas' && 'Ejecutivo de finanzas' }
          { typeView === 'homeProcesos' && 'Ejecutivo de procesos' }
        </p>
      </Col>
    </Row>
  )
}

export default TablaRecibos;
